import {
    createMedicalRecordLegacy,
    deleteMedicalRecordLegacy
} from '@/services/endpoints/medicalRecordLegacy'


export default {

    async createMedicalRecordLegacy({commit}, payload) {
        try {
            let res = await createMedicalRecordLegacy(payload.userId, payload.formData);
            if (res) {
                return res.data
            } else {
                throw {}
            }
        } catch (err) {
            throw err
        }
    },

    async deleteMedicalRecordLegacy({commit}, payload) {
        try {
            let res = await deleteMedicalRecordLegacy(payload.userId);
            if (res) {
                return res.data
            } else {
                throw {}
            }
        } catch (err) {
            throw err
        }
    },

}